import React, { KeyboardEvent, useContext, useState } from "react";
import { AccountContext } from "./AccountContext";
import { FilteringButton } from "./filtering/FilterModal";
import { FilterAction } from "./filtering/FilterAction";
import { SortingButton } from "./sorting/SortingModal";


export default function AccountFilterBox(){
    const {dispatch, filters} = useContext(AccountContext);
    const [text, setText] = useState(filters?.filter || "");

    function doSearch(e:KeyboardEvent){
       if(e.key == "Enter")
            dispatch({type: FilterAction.setFilter, payload: text});
    }

    return <div className="text-center my-2 d-flex d-print-none">
        <input type="text" placeholder="Busca..." className="form-control" style={{maxWidth: "600px"}} enterKeyHint="search" value={text} onChange={(e) => setText(e.target.value)} onKeyUp={doSearch} />
        <SortingButton />
        <FilteringButton />
    </div>
}